import { AutocompleteService } from '@shared/services/autocomplete.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DatepickerService } from '@shared/services/datepicker.service';
import { JalaliService } from '@shared/components/datepicker/services/datepicker.service';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import * as moment from 'jalali-moment';
import { SwiperService } from '@shared/services/swiper-config.service';
import { SharedModule } from '@shared/shared.module';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';

import {
 AfterViewInit,
 ChangeDetectionStrategy,
 ChangeDetectorRef,
 Component,
 computed,
 effect,
 ElementRef,
 EventEmitter,
 HostListener,
 Inject,
 inject,
 Input,
 OnInit,
 Output,
 PLATFORM_ID,
 QueryList,
 signal,
 ViewChildren,
} from '@angular/core';
import { PdpDatepickerComponent } from '../../../components/pdp-datepicker/pdp-datepicker.component';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { range } from 'rxjs';
import { GetEcolodgeDateInfoPipe } from '../../../../../shared/pipes/get-ecolodge-date-info.pipe';
import { EcolodgePdpNightLimitsComponent } from '../../../components/ecolodge-pdp-night-limits/ecolodge-pdp-night-limits.component';
import { EcolodgeService } from '../../../services/ecolodge.service';
import { TransitionCheckState } from '@angular/material/checkbox';
import { HotelInfoUiService } from '../../../services/hotel-info-ui.service';
import { runInThisContext } from 'vm';
@Component({
 selector: 'iho-pdp-ecolodge-calender-price',
 standalone: true,
 imports: [CommonModule, SharedModule, PdpDatepickerComponent, EcolodgePdpNightLimitsComponent],
 templateUrl: './pdp-ecolodge-calender-price.component.html',
 providers: [GetEcolodgeDateInfoPipe],
 styleUrls: ['./pdp-ecolodge-calender-price.component.scss'],
 changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdpEcolodgeCalenderPriceComponent implements OnInit, AfterViewInit {
 @ViewChildren('cell') cell!: QueryList<ElementRef>;
 @ViewChildren('cellInput') cellInput!: QueryList<ElementRef>;
 swiperService = inject(SwiperService);
 getDateDetail = inject(GetEcolodgeDateInfoPipe);
 persianToEnglishPipe = inject(PersianToEnglishRegexPipe);
 ecolodgeService = inject(EcolodgeService);
 pdpUiService = inject(HotelInfoUiService);

 @Output() triggerSearch: EventEmitter<boolean> = new EventEmitter(false);
 @Output() _isShow: EventEmitter<boolean> = new EventEmitter(false);
 @Output() _resetEcolodgeInfoResults: EventEmitter<boolean> = new EventEmitter(false);
 @Input() accommodationInfo: any;
 @Input() set showNopModal(value: boolean) {
  this.showSearchBar = value;
 }

 cdr = inject(ChangeDetectorRef);
 datepickerService = inject(DatepickerService);
 autocompleteService = inject(AutocompleteService);
 searchBoxService = inject(SearchBoxService);
 reservable: boolean = false;
 showSearchBar = false;
 csrStatus = signal<boolean>(false);
 initialYear = signal<number>(+this.datepickerService._startDate().split('/')[0]);

 customEndDate = '';
 customStartDate = '';
 isMobile = signal(
  isPlatformBrowser(this.platformId) ? /Android|iPhone/.test(window.navigator.userAgent) : undefined
 );
 datepickerPack: any = [];
 datepickerVisibility = [false, false, true, true, true, true, true, true, true, true, true, true];
 desktopToggle: number[] = [0, 1];
 duration: string[] = [];
 isNextMonthLoading = this.datepickerService.isNextMonthLoading();
 isPrevMonthLoading = this.datepickerService.isPrevMonthLoading();
 endDate = '';
 isShow: boolean = true;
 gregorianToday = moment().format('YYYY/MM/DD');
 initialCounter = 0;
 jalaliToday = moment().locale('fa').format('YYYY/MM/DD');
 notAllowCursorNextMonth = false;
 notAllowCursorPrevMonth = true;
 startDate = '';
 tip = '';
 configSwiperComments: any;
 calenderMonthCounter = 1;
 isCalenderPriceFetched = computed(() =>
  this.datepickerService.ecolodgeCalenderDetails() ? true : false
 );

 constructor(
  private JalaliService: JalaliService,
  @Inject(PLATFORM_ID) private platformId: Record<string, string>
 ) {
  if (isPlatformBrowser(this.platformId)) {
   this.csrStatus.set(true);
  }

  effect(() => {
   if (+this.datepickerService._endDateShab().split('/')[0] == 1403) this.calenderMonthCounter = 12;

  });
 }

 @HostListener('document:click', ['$event']) clickout(event: any) {
  if (this.datepickerService._isMobile() === false) {
   if (!event.target.closest('.iho-datepicker')) {
    this.datepickerService.setAllowToShow(false);
   }
  }
 }

 jalaliCalendar(sectionNumber: number, prevYearToNextTransition: boolean = false) {
  const yearDif =
   +this.datepickerService._startDate().split('/')[0] - +this.jalaliToday.split('/')[0];

  const monthArray = [
   '',
   'فروردین',
   'اردیبهشت',
   'خرداد',
   'تیر',
   'مرداد',
   'شهریور',
   'مهر',
   'آبان',
   'آذر',
   'دی',
   'بهمن',
   'اسفند',
  ];

  const jalaliDate = moment()
   .locale('fa')
   .add(0 + sectionNumber, 'month')
   .add(
    prevYearToNextTransition
     ? 1
     : (yearDif && +this.datepickerService._startDate().split('/')[0] + 1 < 1405) ||
       this.initialYear() == 1404
     ? yearDif
     : 0,
    'year'
   )
   .format('YYYY/MM/DD');


  const jalaliDateArray = jalaliDate.split('/');

  // jalaliDateArray[0] == this.datepickerService._startDate().split('/')[0] ? jalaliDateArray[0] : this.datepickerService._startDate().split('/')[0]
  const jalaliYear = jalaliDateArray[0];
  const jalaliMonth = jalaliDateArray[1];
  const jalalitDay = 1;
  const daysOfMonth = this.JalaliService.daysOfMonth(+jalaliMonth, +jalaliYear);
  const gregorianDateArray = this.JalaliService.convertToGregorian(
   +jalaliYear,
   +jalaliMonth,
   jalalitDay
  );

  const gregorianDate = `${gregorianDateArray[0]}/${('0' + gregorianDateArray[1]).slice(-2)}/${(
   '0' + gregorianDateArray[2]
  ).slice(-2)}`;
  const gregorianFullDate = moment(gregorianDate).locale('en').format('dddd');

  this.datepickerPack.push({
   sectionYear: +jalaliYear,
   sectionMonth: +jalaliMonth,
   sectionMonthTitle: monthArray[+jalaliMonth],
   sectionDaysOfMonthArray: Array(
    daysOfMonth + this.JalaliService.firstDayOfMonth(gregorianFullDate)
   ).fill(0),
   sectionFirstDay: this.JalaliService.firstDayOfMonth(gregorianFullDate),
  });
 }

 gregorianCalendar(sectionNumber: number) {
  const monthArray = [
   '',
   'ژانویه',
   'فوریه',
   'مارس',
   'آپریل',
   'مه',
   'ژوئن',
   'جولای',
   'آگوست',
   'سپتامبر',
   'اکتبر',
   'نوامبر',
   'دسامبر',
  ];
  const todayHelper = new Date(
   new Date().getFullYear(),
   new Date().getMonth() + sectionNumber,
   new Date().getDate()
  ).toLocaleDateString('en-GB', { dateStyle: 'short', numberingSystem: 'latn' });
  const today = `${todayHelper.split('/')[2]}/${todayHelper.split('/')[1]}/${
   todayHelper.split('/')[0]
  }`;
  const todayArray = today.split('/');
  const gregorianYear = todayArray[0];
  const gregorianMonth = todayArray[1];
  const gregorianFullDate = new Date(
   `${todayHelper.split('/')[2]}/${todayHelper.split('/')[1]}/1`
  ).toLocaleDateString('en-GB', { dateStyle: 'full', numberingSystem: 'latn' });
  this.datepickerPack.push({
   sectionYear: +gregorianYear,
   sectionMonth: +gregorianMonth,
   sectionMonthTitle: monthArray[+gregorianMonth],
   sectionDaysOfMonthArray: Array(new Date(+gregorianYear, +gregorianMonth, 0).getDate()).fill(0),
   sectionFirstDay: this.JalaliService.firstDayOfMonth(gregorianFullDate),
  });
 }

 changeLocate(locale: string) {
  // will be back soon (new way)
 }

  navigateMonth(type: string) {
    const fetchedMonthes = this.datepickerService.fetchedMonthes();
    if (type === 'next') {
      const month =
        this.calenderMonthCounter + 2 > 12
          ? this.calenderMonthCounter + 2 - 12
          : this.calenderMonthCounter + 2;
      const year =
        this.calenderMonthCounter + 2 > 12
          ? +this.datepickerService._startDate().split('/')[0] + 1
          : +this.datepickerService._startDate().split('/')[0];

      if (
        !fetchedMonthes.find((fetched) => fetched.month == month && fetched.year == year) &&
        this.calenderMonthCounter < +this.datepickerService.todayJalali().split('/')[1] + 12
      ) {
        this.datepickerService.isNextMonthLoading.set(true);
        this.ecolodgeService.getCalenderDetails(
          `${year}/${month}/${1}`,
          this.datepickerService._endDate()
        );
        this.datepickerService.fetchedMonthes.update(() => [
          ...fetchedMonthes,
          {
            year: year,
            month: month,
          },
        ]);
      }

      if (this.calenderMonthCounter < +this.datepickerService.todayJalali().split('/')[1] + 12)
        this.calenderMonthCounter++;

      if (this.initialCounter <= 10) {
        this.notAllowCursorNextMonth = false;
        this.notAllowCursorPrevMonth = false;
        this.datepickerPack = [];
        if (this.datepickerService._locale() === 'fa') {
          this.jalaliCalendar(this.initialCounter);
          this.initialCounter = this.initialCounter + 1;
          this.jalaliCalendar(this.initialCounter);
        }
        if (this.datepickerService._locale() === 'en') {
          this.gregorianCalendar(this.initialCounter);
          this.initialCounter = this.initialCounter + 1;
          this.gregorianCalendar(this.initialCounter);
        }
      }
      if (this.initialCounter > 10) {
        this.notAllowCursorNextMonth = true;
      }
    }
    if (type === 'previous') {
      const month =
        this.calenderMonthCounter - 1 > 12
          ? Math.abs(this.calenderMonthCounter - 1 - 12)
          : this.calenderMonthCounter - 1;
      const year =
        this.calenderMonthCounter - 1 > 12
          ? +this.datepickerService._startDate().split('/')[0] + 1
          : +this.datepickerService._startDate().split('/')[0];

      if (
        !fetchedMonthes.find((fetched) => fetched.month == month && fetched.year == year) &&
        month >= +this.datepickerService.todayJalali().split('/')[1]
      ) {
        this.datepickerService.isPrevMonthLoading.set(true);

        this.ecolodgeService.getCalenderDetails(
          `${year}/${month}/${1}`,
          this.datepickerService._endDate()
        );
        this.datepickerService.fetchedMonthes.update(() => [
          {
            year: year,
            month: month,
          },
          ...fetchedMonthes,
        ]);
      }

      if (this.calenderMonthCounter - 1 >= +this.datepickerService.todayJalali().split('/')[1])
        this.calenderMonthCounter--;

      if (this.initialCounter >= 2) {
        this.notAllowCursorPrevMonth = false;
        this.notAllowCursorNextMonth = false;
        this.datepickerPack = [];
        if (this.datepickerService._locale() === 'fa') {
          this.initialCounter = this.initialCounter - 2;
          this.jalaliCalendar(this.initialCounter);
          this.initialCounter = this.initialCounter + 1;
          this.jalaliCalendar(this.initialCounter);
        }
        if (this.datepickerService._locale() === 'en') {
          this.initialCounter = this.initialCounter - 2;
          this.gregorianCalendar(this.initialCounter);
          this.initialCounter = this.initialCounter + 1;
          this.gregorianCalendar(this.initialCounter);
        }
      }
      if (this.initialCounter < 2) {
        this.notAllowCursorPrevMonth = true;
      }
    }
    this.reArrangeDate();
  }

 reArrangeDate() {
  if (isPlatformBrowser(this.platformId)) {
   setTimeout(() => {
    this.cell?.toArray().forEach((obj) => {
     obj.nativeElement.classList.remove('start-date');
     obj.nativeElement.classList.remove('end-date');
     obj.nativeElement.classList.remove('duration');
    });
    const startDateArray = this.datepickerService._startDate().split('/');
    const startDateHelper = `${startDateArray[0]}/${('0' + startDateArray[1]).slice(-2)}/${(
     '0' + startDateArray[2]
    ).slice(-2)}`;
    const endDateArray = this.datepickerService._endDate().split('/');
    const endDateHelper = `${endDateArray[0]}/${('0' + endDateArray[1]).slice(-2)}/${(
     '0' + endDateArray[2]
    ).slice(-2)}`;
    this.cellInput.toArray().forEach((obj) => {
     const cellDateHelper = `${obj.nativeElement.value.split('/')[0]}/${(
      '0' + obj.nativeElement.value.split('/')[1]
     ).slice(-2)}/${('0' + obj.nativeElement.value.split('/')[2]).slice(-2)}`;
     if (startDateHelper === cellDateHelper) {
      obj.nativeElement.closest('.cell').classList.add('start-date');
     }
     if (endDateHelper === cellDateHelper) {
      obj.nativeElement.closest('.cell').classList.add('end-date');
     }
     if (startDateHelper <= cellDateHelper && endDateHelper >= cellDateHelper) {
      obj.nativeElement.closest('.cell').classList.add('duration');
     }
    });
   });
  }
 }

 reset() {
  const fetchedMonthes = this.datepickerService.fetchedMonthes();

  this.cell.toArray().forEach((obj) => {
   obj.nativeElement.classList.remove('start-date');
   obj.nativeElement.classList.remove('end-date');
   obj.nativeElement.classList.remove('duration');
  });
  this.endDate = '';
  this.customEndDate = '';
  this.startDate = '';
  this.customStartDate = '';
  this.notAllowCursorNextMonth = false;
  this.notAllowCursorPrevMonth = true;
  this.desktopToggle = [0, 1];
  this.datepickerService.setStartDate(this.jalaliToday);
  this.datepickerService.setCustomStartDate('');
  this.datepickerService.setEndDate('');
  this.datepickerService.setCustomEndDate('');
  this.datepickerPack = [];
  this.duration = [];
  this.initialCounter = 0;
  if (this.datepickerService._locale() === 'fa') {
   this.jalaliCalendar(this.initialCounter);
   this.jalaliCalendar(this.initialCounter + 1);
   this.initialCounter = 1;

   const boundBackMonthCount = Math.abs(
    this.calenderMonthCounter -
     (this.jalaliToday.split('/')[1][0] == '0'
      ? +this.jalaliToday.split('/')[1][1]
      : +this.jalaliToday.split('/')[1])
   );

   //  this.datepickerService.isNextMonthLoading.set(true);

   for (let i = 0; i < boundBackMonthCount; i++) {
    this.navigateMonth('previous');
   }
  }
  if (this.datepickerService._locale() === 'en') {
   this.gregorianCalendar(this.initialCounter);
   this.gregorianCalendar(this.initialCounter + 1);
   this.initialCounter = 1;
  }
 }

 isDisable(year: number, month: number, day: number): boolean {
  let minDate = '';
  if (this.datepickerService._locale() === 'fa') {
   let minDateHelper = this.datepickerService._minDate();
   minDate = `${minDateHelper.split('/')[0]}/${('0' + minDateHelper.split('/')[1]).slice(-2)}/${(
    '0' + minDateHelper.split('/')[2]
   ).slice(-2)}`;
  }
  if (this.datepickerService._locale() === 'en') {
   let minDateHelper = this.JalaliService.convertToGregorian(
    +this.datepickerService._minDate().split('/')[0],
    +this.datepickerService._minDate().split('/')[1],
    +this.datepickerService._minDate().split('/')[2]
   );
   minDate = `${minDateHelper[0]}/${('0' + minDateHelper[1]).slice(-2)}/${(
    '0' + minDateHelper[2]
   ).slice(-2)}`;
  }
  const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
  const maxDateArray = this.datepickerService._minDate().split('/');
  const maxDateString = `${maxDateArray[0]}/${('0' + maxDateArray[1]).slice(-2)}/${(
   '0' + maxDateArray[2]
  ).slice(-2)}`;
  let result = true;
  if (this.datepickerService._minDate() === '' && this.datepickerService._maxDate() === '') {
   this.datepickerService._disable().forEach((obj: any) => {
    if (cellDate === obj) {
     result = false;
    }
   });
  }
  if (this.datepickerService._minDate() !== '' && cellDate < minDate) {
   result = false;
  }
  if (this.datepickerService._maxDate() !== '' && cellDate > maxDateString) {
   result = false;
  }
  return result;
 }

 isUnreservable(year: number, month: number, day: number): number {
  const DateDetail: any = this.getDateDetail.transform(
   this.getDateString(year.toString(), month.toString(), day.toString())
  );

  const dayBefore = this.getDateDetail.transform(
   this.getDateString(year.toString(), month.toString(), (day - 1).toString())
  );

  const isTheDayBeforeUnreservable = dayBefore?.IsNonBookable || dayBefore?.ReservableStatus == 2;

  return (
   (DateDetail?.IsNonBookable || DateDetail?.ReservableStatus == 2) &&
   (dayBefore != undefined ? isTheDayBeforeUnreservable : true)
  );

  //   this.showSearchBar = false;
  //   this.datepickerService.setState(true);
  //   this.datepickerService.setAllowToShow(true);
 }

 isHoliday(year: number, month: number, day: number): boolean {
  let result = false;
  if (this.datepickerService._holidays()) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   this.datepickerService._holidays().forEach((obj: any) => {
    if (cellDate === obj.PersianDate) {
     result = true;
    }
   });
  }
  return result;
 }

 hasPrice(year: number, month: number, day: number): string {
  let result = '0';
  if (this.datepickerService._price().length !== 0) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   this.datepickerService._price().forEach((obj: any) => {
    if (cellDate === obj.date) {
     result = obj.amount.toLocaleString();
    }
   });
  }
  return result;
 }

 hasWeather(year: number, month: number, day: number): string {
  let result = '0';
  if (this.datepickerService._weather().length !== 0) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   this.datepickerService._weather().forEach((obj: any) => {
    if (cellDate === obj.date) {
     result = obj.forcast;
    }
   });
  }
  return result;
 }

 hasNoPrice(year: string, month: string, day: string): boolean {
  return this.getDateDetail.transform(this.getDateString(year, month, day))?.Price?.NoPrice;
 }

 selectDate(year: number, month: number, day: number, event: any) {
  let monthArray: string[] = [];
  if (this.datepickerService._locale() === 'fa') {
   monthArray = [
    '',
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
   ];
  }
  if (this.datepickerService._locale() === 'en') {
   monthArray = [
    '',
    'ژانویه',
    'فوریه',
    'مارس',
    'آپریل',
    'مه',
    'ژوئن',
    'جولای',
    'آگوست',
    'سپتامبر',
    'اکتبر',
    'نوامبر',
    'دسامبر',
   ];
  }
  const cellDate = `${year}/${month}/${day}`;
  const cellDateHelper = `${year}/${(0 + month.toString()).slice(-2)}/${(0 + day.toString()).slice(
   -2
  )}`;
  const minDateArray = this.datepickerService._minDate().split('/');
  const minDateString = `${minDateArray[0]}/${('0' + minDateArray[1]).slice(-2)}/${(
   '0' + minDateArray[2]
  ).slice(-2)}`;
  if (!event.target.querySelector('.diagonal.gray')) {
   if (cellDateHelper >= minDateString) {
    this.cell.toArray().forEach((obj) => {
     obj.nativeElement.classList.remove('duration');
    });
    this.duration = [];
    if (this.startDate !== '' && this.endDate !== '') {
     this.startDate = '';
     this.endDate = '';
     this.cell.toArray().forEach((obj) => {
      obj.nativeElement.classList.remove('start-date');
      obj.nativeElement.classList.remove('end-date');
     });
    }
    if (this.startDate === '' && !event.target.querySelector('.diagonal.orange')) {
     this.startDate = cellDate;
     this.customStartDate = `${cellDate.split('/')[2]} ${monthArray[+cellDate.split('/')[1]]}`;
     this.datepickerService.setStartDate(cellDate);
     this.datepickerService.setStartDateShab(cellDate);
     // this.datepickerService.setstart(cellDate);
     this.datepickerService.setCustomStartDate(this.customStartDate);
     this.endDate = '';
     this.datepickerService.setEndDate('');
     this.datepickerService.setEndDateShab('');
     this.datepickerService.setCustomEndDate('');
     event.target.closest('.cell').classList.add('start-date');
    } else if (
     this.startDate !== '' &&
     this.endDate === '' &&
     !event.target.querySelector('.diagonal.red')
    ) {
     this.endDate = cellDate;
     this.customEndDate = `${cellDate.split('/')[2]} ${monthArray[+cellDate.split('/')[1]]}`;
     const startDateHelper = `${this.startDate.split('/')[0]}/${(
      0 + this.startDate.split('/')[1].toString()
     ).slice(-2)}/${(0 + this.startDate.split('/')[2].toString()).slice(-2)}`;
     if (cellDateHelper <= startDateHelper) {
      this.cell.toArray().forEach((obj) => {
       obj.nativeElement.classList.remove('start-date');
      });
      this.startDate = cellDate;
      this.customStartDate = `${cellDate.split('/')[2]} ${monthArray[+cellDate.split('/')[1]]}`;
      this.datepickerService.setStartDate(cellDate);
      this.datepickerService.setStartDateShab(cellDate);
      this.datepickerService.setCustomStartDate(this.customStartDate);
      this.endDate = '';
      this.datepickerService.setEndDate('');
      this.datepickerService.setEndDateShab('');
      this.datepickerService.setCustomEndDate('');
      event.target.closest('.cell').classList.add('start-date');
     } else {
      this.setDuration();
      this.datepickerService.setEndDate(this.endDate);
      this.datepickerService.setEndDateShab(this.endDate);
      this.datepickerService.setCustomEndDate(this.customEndDate);
      event.target.closest('.cell').classList.add('end-date');
      const endDateArray = this.endDate.split('/');
      const endDateHelper = `${endDateArray[0]}/${('0' + endDateArray[1]).slice(-2)}/${(
       '0' + endDateArray[2]
      ).slice(-2)}`;
      this.cellInput.toArray().forEach((obj) => {
       const cellDateHelper = `${obj.nativeElement.value.split('/')[0]}/${(
        '0' + obj.nativeElement.value.split('/')[1]
       ).slice(-2)}/${('0' + obj.nativeElement.value.split('/')[2]).slice(-2)}`;
       if (startDateHelper <= cellDateHelper && endDateHelper >= cellDateHelper) {
        obj.nativeElement.closest('.cell').classList.add('duration');
       }
      });
     }
    }
   }

   this.setUnReservable(year, month, day);
  }
 }

 setUnReservable = (year: number, month: number, day: number) => {
  const cellDateHelper = `${year}/${(0 + month.toString()).slice(-2)}/${(0 + day.toString()).slice(
   -2
  )}`;
  if (this.datepickerService._unReservable().length !== 0 && this.startDate !== '') {
   let startLimit = '';
   for (let i = 0; i < this.datepickerService._unReservable().length; i++) {
    const cellHelper = `${this.datepickerService._unReservable()[i].split(',')[0].split('/')[0]}/${(
     0 + this.datepickerService._unReservable()[i].split(',')[0].split('/')[1].toString()
    ).slice(-2)}/${(
     0 + this.datepickerService._unReservable()[i].split(',')[0].split('/')[2].toString()
    ).slice(-2)}`;
    if (
     (cellDateHelper < cellHelper &&
      +this.datepickerService._unReservable()[i].split(',')[1] === 3) ||
     (cellDateHelper < cellHelper &&
      +this.datepickerService._unReservable()[i].split(',')[1] === 4) ||
     (cellDateHelper < cellHelper && +this.datepickerService._unReservable()[i].split(',')[1] === 2)
    ) {
     startLimit = `${this.datepickerService._unReservable()[i].split(',')[0].split('/')[0]}/${(
      0 + this.datepickerService._unReservable()[i].split(',')[0].split('/')[1].toString()
     ).slice(-2)}/${(
      0 + this.datepickerService._unReservable()[i].split(',')[0].split('/')[2].toString()
     ).slice(-2)}`;
     break;
    }
   }

   if (startLimit) {
    const unReservable: string[] = [];
    this.cellInput.toArray().forEach((obj) => {
     const cellHelper = `${obj.nativeElement.value.split('/')[0]}/${(
      0 + obj.nativeElement.value.split('/')[1].toString()
     ).slice(-2)}/${(0 + obj.nativeElement.value.split('/')[2].toString()).slice(-2)}`;
     if (cellHelper > startLimit) {
      unReservable.push(`${obj.nativeElement.value},2`);
     }
    });
    if (+unReservable[0].split(',')[1] !== 2) {
     unReservable.shift();
    }

    this.datepickerService.setUnReservable(
     this.datepickerService._unReservable().concat(unReservable)
    );
   }
  }
 };

 setDuration() {
  //   this.cdr.detectChanges();

  this.duration = [];
  let startDateArray: string[] = [];
  let endDateArray: string[] = [];
  startDateArray = this.startDate.split('/');
  endDateArray = this.endDate.split('/');
  const startYear = +startDateArray[0];
  const startMonth = +startDateArray[1];
  const startDay = +startDateArray[2];
  const startDayNumber = this.JalaliService.daysOfMonth(startMonth, startYear);
  const endYear = +endDateArray[0];
  const endMonth = +endDateArray[1];
  const endDay = +endDateArray[2];
  if (startMonth === endMonth && startDay !== endDay) {
   let sd = startDay;
   for (let i = sd; sd <= endDay; i++) {
    this.duration.push(`${startYear}/${startMonth}/${sd}`);
    sd++;
   }
  }

  if (startMonth < endMonth) {
   let sm = startMonth;
   let sd = startDay;
   let ed = endDay;
   const durationHelper1: string[] = [];
   const durationHelper2: string[] = [];
   for (let i = sm; sm <= endMonth; i++) {
    for (let j = sd; sd <= startDayNumber; j++) {
     durationHelper1.push(`${startYear}/${sm}/${sd}`);
     sd++;
    }
    for (let j = sd; ed >= 1; j++) {
     durationHelper2.push(`${endYear}/${endMonth}/${ed}`);
     ed--;
    }
    sm++;
   }
   this.duration = durationHelper1.concat(durationHelper2.reverse());
  }
  if (startMonth > endMonth) {
   const sm = startMonth;
   const em = endMonth;
   let sd = startDay;
   let ed = endDay;
   const durationHelper1: string[] = [];
   const durationHelper2: string[] = [];
   for (let i = sd; sd <= startDayNumber; i++) {
    durationHelper1.push(`${startYear}/${sm}/${sd}`);
    sd++;
   }
   for (let i = ed; ed >= 1; i--) {
    durationHelper2.push(`${endYear}/${em}/${ed}`);
    ed--;
   }
   this.duration = durationHelper1.concat(durationHelper2.reverse());
  }
  this.datepickerService.setSelectedNights(this.duration);
  //  this.cdr.detectChanges();
  this.handleCalenderValidations();
 }

 submitDate() {
  //   this.datepickerService.reservable.set(false);
  if (this.datepickerService._allowToShow()) {
   this.datepickerService.setSelectedDate(this.duration);
   //    this.datepickerService.setState(false);
   if (this.autocompleteService._selectedItem().id === undefined) {
    setTimeout(() => {
     this.autocompleteService.setState('favorite');
    });
   }
  } else {
   this.triggerSearch.emit(true);
  }
 }

 setTooltip(year: number, month: number, day: number) {
  if (this.datepickerService._unReservable().length === 0) {
   const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
   let result = '';
   if (this.datepickerService._holidays()) {
    this.datepickerService._holidays().forEach((obj: any) => {
     if (cellDate === obj.PersianDate) {
      result = obj.Description;
     }
    });
   }
   this.tip = result;
  } else {
   let result = '';
   if (this.datepickerService._unReservable().length !== 0) {
    const cellDate = `${year}/${('0' + month).slice(-2)}/${('0' + day).slice(-2)}`;
    this.datepickerService._unReservable().forEach((obj: any) => {
     const cellHelper = `${obj.split(',')[0].split('/')[0]}/${(
      0 + obj.split(',')[0].split('/')[1].toString()
     ).slice(-2)}/${(0 + obj.split(',')[0].split('/')[2].toString()).slice(-2)}`;
     if (cellDate === cellHelper && +obj.split(',')[1] === 2) {
      result = '1';
     }
     if (cellDate === cellHelper && +obj.split(',')[1] === 3) {
      result = '2';
     }
     if (cellDate === cellHelper && +obj.split(',')[1] === 4) {
      result = '3';
     }
    });
   }
   this.tip = result;
  }
 }

 setInitialDate() {
  if (this.datepickerService._startDate() && this.datepickerService._endDate()) {
   this.datepickerService.setStartDateShab(this.datepickerService._startDate());
   this.datepickerService.setEndDateShab(this.datepickerService._endDate());
   this.cdr.detectChanges();
   const monthArray = [
    '',
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
   ];
   const startDateArray = this.datepickerService._startDate().split('/');
   const startDateHelper = `${startDateArray[0]}/${('0' + startDateArray[1]).slice(-2)}/${(
    '0' + startDateArray[2]
   ).slice(-2)}`;
   const endDateArray = this.datepickerService._endDate().split('/');
   const endDateHelper = `${endDateArray[0]}/${('0' + endDateArray[1]).slice(-2)}/${(
    '0' + endDateArray[2]
   ).slice(-2)}`;
   this.startDate = `${startDateArray[0]}/${startDateArray[1]}/${startDateArray[2]}`;
   this.endDate = `${endDateArray[0]}/${endDateArray[1]}/${endDateArray[2]}`;
   this.customStartDate = `${this.datepickerService._startDate().split('/')[2]} ${
    monthArray[+this.datepickerService._startDate().split('/')[1]]
   }`;
   this.customEndDate = `${this.datepickerService._endDate().split('/')[2]} ${
    monthArray[+this.datepickerService._endDate().split('/')[1]]
   }`;
   this.datepickerService.setCustomStartDate(this.customStartDate);
   this.datepickerService.setCustomEndDate(this.customEndDate);
   this.cell?.toArray().forEach((obj) => {
    obj.nativeElement.classList.remove('start-date');
    obj.nativeElement.classList.remove('end-date');
    obj.nativeElement.classList.remove('duration');
   });
   this.cellInput?.toArray().forEach((obj) => {
    const cellDateHelper = `${obj.nativeElement.value.split('/')[0]}/${(
     '0' + obj.nativeElement.value.split('/')[1]
    ).slice(-2)}/${('0' + obj.nativeElement.value.split('/')[2]).slice(-2)}`;
    if (startDateHelper === cellDateHelper) {
     obj.nativeElement.closest('.cell').classList.add('start-date');
    }
    if (endDateHelper === cellDateHelper) {
     obj.nativeElement.closest('.cell').classList.add('end-date');
    }
    if (startDateHelper <= cellDateHelper && endDateHelper >= cellDateHelper) {
     obj.nativeElement.closest('.cell').classList.add('duration');
    }
   });
  }
  this.cdr.detectChanges();

  this.setDuration();
 }
 ngAfterViewInit(): void {
  setTimeout(() => {
   this.setInitialDate();
  }, 2000);
 }
 ngOnInit(): void {
  this.calenderMonthCounter = +this.datepickerService._startDate().split('/')[1];
  this.initialCounter =
   +this.datepickerService._startDate().split('/')[1] - +this.jalaliToday.split('/')[1];

  if (this.initialCounter != 0) this.notAllowCursorPrevMonth = false;

  let config = {
   slide: 'auto',
   pagination: {
    enabled: false,
    clickable: false,
   },
  };
  this.configSwiperComments = this.swiperService.SwiperConfig(config);
  this.reservable = this.datepickerService.reservable();
  if (this.datepickerService._locale() === 'fa') {
   this.jalaliCalendar(this.initialCounter);
   this.jalaliCalendar(this.initialCounter + 1);
   this.initialCounter = this.initialCounter + 1;
  }
  if (this.datepickerService._locale() === 'en') {
   this.gregorianCalendar(this.initialCounter);
   this.gregorianCalendar(this.initialCounter + 1);
   this.initialCounter = 1;
  }

  this.datepickerService.todayJalali.set(this.jalaliToday);
 }
 setToggle() {
  this.datepickerService.setState(false);
  this.datepickerService.setAllowToShow(false);
  this.showSearchBar = true;
 }
 isShowemitfunc(ev: boolean) {
  this._isShow.emit(ev);
  this.showSearchBar = ev;
 }

 goToRoomSection(parameters: any) {
  this.startDate = parameters.startDate;
  this.endDate = parameters.endDate;
  this.setInitialDate();

  this.datepickerService.setState(true);
  this.datepickerService.setAllowToShow(true);
 }

 getDateString(year: string, month: string, day: string) {
  return `${year}/${month}/${day}`;
 }

 resetEcolodgeInfoResults() {
  this._resetEcolodgeInfoResults.emit();
 }

 isEcolodgeNonBookable(year: string, month: string, day: number): boolean {
  return this.getDateDetail.transform(this.getDateString(year, month, day.toString()))
   ?.IsNonBookable;
 }

 handleCalenderValidations() {
  let NonBookableDates = [];
  let NightLimitDates: any = [];
  let storedMinBookDays = 0;
  let storedMaxBookDays = 0;

  this.duration.forEach((date) => {
   const dayBefore = this.getDateDetail.transform(
    this.getDateString(date.split('/')[0], date.split('/')[1], (+date.split('/')[2] - 1).toString())
   );
   const isTheDayBeforeUnreservable = dayBefore?.IsNonBookable || dayBefore?.ReservableStatus == 2;

   if (
    ((this.getDateDetail.transform(date)?.IsNonBookable ||
     this.getDateDetail.transform(date)?.ReservableStatus == 2) &&
     (dayBefore != undefined ? isTheDayBeforeUnreservable : true)) ||
    this.getDateDetail.transform(date)?.Price.NoPrice
   ) {
    NonBookableDates.push(date);
   }

   //  nights limits

   // MinBookDays

   const LimitTo = this.datepickerService._ihoNightLimit();
   if (
    this.getDateDetail.transform(date) &&
    this.getDateDetail.transform(date).MinBookDays &&
    storedMinBookDays < this.getDateDetail.transform(date).MinBookDays
   ) {
    storedMinBookDays = this.getDateDetail.transform(date).MinBookDays;
   }

   // MaxBookDays
   if (
    this.getDateDetail.transform(date).MaxBookDays &&
    storedMaxBookDays < this.getDateDetail.transform(date).MaxBookDays
   ) {
    storedMaxBookDays = this.getDateDetail.transform(date).MaxBookDays;
   }

   if (this.duration.length - 1 < storedMinBookDays || this.duration.length - 1 < LimitTo) {
    NightLimitDates.push(date);
   }
  });

  this.datepickerService.setNightLimit(storedMinBookDays);

  if (NonBookableDates.length) {
   this.datepickerService.calenderErrors.set({
    NonBookable: true,
    NightLimits: this.datepickerService.calenderErrors().NightLimits,
   });
  } else {
   this.datepickerService.calenderErrors.set({
    NonBookable: false,
    NightLimits: this.datepickerService.calenderErrors().NightLimits,
   });
  }

  // Night limits

  if (NightLimitDates.length) {
   this.datepickerService.calenderErrors.set({
    NonBookable: this.datepickerService.calenderErrors().NonBookable,
    NightLimits: true,
   });
  } else {
   this.datepickerService.calenderErrors.set({
    NonBookable: this.datepickerService.calenderErrors().NonBookable,
    NightLimits: false,
   });
  }
 }
}
